import React, {useEffect, useState, useContext} from 'react';
import {Scrollbars} from 'react-custom-scrollbars';
import {Col, Row} from 'reactstrap';
import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import InputSearch from '../../components/inputSearch';
import ReactSelect from '../../components/react-select';
import DeviceListItem from './device-list-item';
import {ThemeContext} from '../../apiContexts';

const DeviceListExpanded = ({list = [], selected, onSelect, ...props}) => {
    const [currentList, setCurrentList] = useState(list);

    const theme = useContext(ThemeContext);

    const filter = (value) => {
        if (!value) {
            setCurrentList(list);
            return;
        }

        value = String(value).toUpperCase();
        const filtered = list.filter(({name}) =>
            String(name)
                .toUpperCase()
                .includes(value),
        );
        setCurrentList(filtered);
    };

    return (
        <div id="deviceListExpanded">
            <div className="shadow h-100">
                <Bar onFilter={filter}/>
                <Scrollbars style={{height: 400}}>
                    <Row id="items" className="py-2">
                        {currentList.map(({name, currentPosition, id, category, status}, i) => (
                            <Col key={i} md="3">
                                <DeviceListItem
                                    key={`DeviceListItem__${id}`}
                                    theme={theme}
                                    category={category}
                                    status={status}
                                    id={id}
                                    name={name}
                                    currentPosition={currentPosition}
                                    onSelect={onSelect}
                                    active={selected && selected.id === id}
                                />
                            </Col>
                        ))}
                    </Row>
                </Scrollbars>
            </div>
        </div>
    );
};

let input$ = null;

const Bar = ({onFilter, ...props}) => {
    useEffect(() => {
        input$ = new Subject();
        input$.pipe(debounceTime(750)).subscribe((value) => onFilter(value));
        return () => input$.unsubscribe();
    }, [onFilter]);

    const filter = ({target: {value}}) => input$.next(value);

    const typeOptions = [
        {id: 'react', title: 'ReactJS'},
        {id: 'node', title: 'NodeJS'},
        {id: 'rn', title: 'React Native'},
    ];

    const typeStatus = [
        {id: 'react', title: 'ReactJS'},
        {id: 'node', title: 'NodeJS'},
        {id: 'rn', title: 'React Native'},
    ];

    return (
        <Row id="bar" className="ml-0 mr-0">
            <Col md="4" style={{borderRight: '2px solid #b8b8b8'}}>
                <InputSearch placeholder="Pesquise para filtrar" onChange={filter}/>
            </Col>
            <Col className="d-flex align-items-center">
                <strong className="w-50 text-left mr-1">Filtar por: </strong>
                <ReactSelect
                    options={typeOptions}
                    scoped={false}
                    name="typeDevice"
                    noOptionsMessage={() => 'Nenhum resultado encontrado!'}
                    placeholder="Dispositivo"
                    className="w-100 mr-1"
                />
                <ReactSelect
                    options={typeOptions}
                    name="typeDevice"
                    scoped={false}
                    noOptionsMessage={() => 'Nenhum resultado encontrado!'}
                    placeholder="Estado"
                    className="w-100 ml-1"
                />
            </Col>
        </Row>
    );
};

export default DeviceListExpanded;
